<template>
  <section class="section">
    <div class="container is-fluid">
      <h1 class="title">{{ $translate('customers') | capitalize }}</h1>
      <!--<b-button
        type="is-primary"
        icon-right="content-save"
        @click="saveAll()"
      ></b-button>-->
      <table-actions v-bind:disabled.sync="tableOptions.loading" v-bind:canCreate="permissions.canCreate"
        v-bind:canHide="permissions.canHide" v-bind:canDelete="permissions.canDelete"
        v-bind:multipleSelectionIcon="multipleSelectionIcon" v-bind:formLink="{
          name: 'newCompany',
        }" :checkedRows.sync="tableOptions.checkedRows" v-on:viewhiddenchange="switchViewHidden"
        v-on:search="searchData" v-on:changesearchQuery="changesearchQuery" v-on:hideItems="DialogHiding"
        v-on:deleteItems="multipleDelete('companies')" />
      <div class="level-left second-level">
        <div class="level-item">
          <p class="is-size-5 has-text-primary">
            {{ $translate('filter') | capitalize }}
          </p>
        </div>
        <div class="level-item">
          <filter-select :disabledbool.sync="disabledcountry" v-model="countriesFilterInfo"
            v-on:change="searchData()" />
        </div>
        <div class="level-item">
          <filter-select v-model="catalogsFilterInfo" v-on:change="searchData()" />
        </div>
      </div>
      <b-table :sticky-header="true" :data="tableData" :narrowed="true" :checked-rows.sync="tableOptions.checkedRows"
        :sort-icon="tableOptions.sortIcon" :sort-icon-size="tableOptions.sortIconSize" :loading="tableOptions.loading"
        :backend-sorting="true" checkable detailed @sort="sortPressed" @check="multipleSelectionIconManage" hoverable
        :row-class="(row, index) => !row.isActive && 'hiding-row'">
        <template slot-scope="props">
          <b-table-column field="mercurio_id" :label="$translate('id_mercury') | capitalize" sortable>{{
            props.row.mercurio_id }}
          </b-table-column>
          <b-table-column field="name" :label="$translate('name') | capitalize" sortable>{{ props.row.name }}
          </b-table-column>
          <b-table-column field="address.country" :label="$translate('country') | capitalize" sortable>{{
            $translate(props.row.address['country']) }}
          </b-table-column>
          <b-table-column field="address.city" :label="$translate('city') | capitalize" sortable>{{
            props.row.address['city'] }}
          </b-table-column>
          <b-table-column field="email" :label="$translate('mail') | capitalize">
            <a :href="'mailto:' + props.row.email">{{ props.row.email }}</a>
          </b-table-column>
          <b-table-column field="catalog" :label="$translate('catalog') | capitalize">
            <company-nav-to-catalog-action :company="props.row" />
          </b-table-column>
          <b-table-column :label="$translate('action') | capitalize">
            <a v-if="permissions.canEdit" @click="
              $router.push({
                name: 'editCompany',
                params: { id: props.row.id },
              })
              ">
              <b-icon icon="pencil-outline"></b-icon>
            </a>
            <!--</router-link>-->
            <a @click="deleteItemModal(props.row, 'companies')" v-if="permissions.canDelete">
              <b-icon icon="delete-outline"></b-icon>
            </a>
            <a @click="
              $router.push({
                name: 'shops',
                params: { companyId: props.row.id },
              })
              ">
              <b-icon icon="format-list-checkbox"></b-icon>
            </a>
          </b-table-column>
        </template>
        <template slot="detail" slot-scope="props">
          <article class="media">
            <div class="media-content">
              <div class="content">
                <p>
                  <strong>{{ $translate('tel') | capitalize }}:</strong>
                  {{ props.row.phone }}
                  <br />
                  <strong>{{ $translate('piva') | capitalize }}:</strong>
                  {{ props.row.vat }}
                  <br />
                  <strong>{{ $translate('address') | capitalize }}:</strong>
                  {{ printAddress(props.row.address) }}
                </p>
              </div>
            </div>
          </article>
        </template>
        <template slot="footer" v-if="!disableRequestMore">
          <b-button @click="appendData()" expanded>
            <b-icon icon="arrow-down-thick"></b-icon>
          </b-button>

          <!--<td>
            <b-icon icon="chevron-right"></b-icon>
          </td>
          <td><b-checkbox disabled></b-checkbox></td>
          <td>{{ lastRequested.data().mercurio_id }}</td>
          <td>{{ lastRequested.data().name }}</td>
          <td>{{ $translate(lastRequested.data().country) }}</td>
          <td>
            {{ lastRequested.data().address.city }}
          </td>
          <td>{{ lastRequested.data().email }}</td>
          <td>...</td>
          <td></td>-->
        </template>
        <template slot="empty">
          <section class="section" v-if="!tableOptions.loading">
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon icon="emoticon-sad" size="is-large"></b-icon>
              </p>
            </div>
          </section>
        </template>
      </b-table>
    </div>
  </section>
</template>

<script>
import firebase from 'firebase'
import mainMixin from '@/helpers/mixins/mainMixin'
import permissionMixin from '@/helpers/mixins/permissionMixin'
import filterSelect from '@/components/FilterSelect'
import tableActions from '@/components/TableActions'
import CompanyNavToCatalogAction from '@/views/Companies/components/CompanyNavToCatalogAction.vue'

export default {
  name: 'companies',
  mixins: [mainMixin, permissionMixin],
  components: {
    'filter-select': filterSelect,
    'table-actions': tableActions,
    'company-nav-to-catalog-action': CompanyNavToCatalogAction,
  },
  data() {
    return {
      field: null,
      order: null,
      queryString: '',
      catalogs: [],
      mainQuery: this.$db.collection('companies').where('isActive', '==', true),
      lastRequested: null,
      disableRequestMore: true,
      disabledcountry: false,
      companiesindex: 0,
      limit: 20,
      countriesFilterInfo: {
        label: 'country',
        options: [{ name: '*' }],
        filterValue: '*',
      },
      catalogsFilterInfo: {
        label: 'catalog',
        options: [{ name: '*' }],
        filterValue: '*',
      },
    }
  },
  methods: {
    /*async saveAll() {
      await this.$db
        .collection("companies")
        .get()
        .then(docs => {
          docs.forEach(doc => {
            let newCom = doc.data();
            newCom.id = doc.id;
            newCom.orders = [];
            this.$db
              .collection("companies")
              .doc(doc.id)
              .update(newCom)
              .then(() => {
                console.log("aggiornato: " + doc.id);
              });
          });
        });
    },*/

    DialogHiding() {
      this.$buefy.dialog.confirm({
        title: this.$translate('attention'),
        message: this.$translate('hide_shops'),
        cancelText: this.$translate('n'),
        confirmText: this.$translate('y'),
        onConfirm: async () => {
          let shopstochange = []
          for (let index in this.tableOptions.checkedRows) {
            //console.log(this.tableOptions.checkedRows[index]);
            await this.$db
              .collection('shops')
              .where('companyId', '==', this.tableOptions.checkedRows[index].id)
              .get()
              .then(docs => {
                docs.forEach(doc => {
                  let shop = doc.data()
                  shop.id = doc.id
                  shop.isActive = !this.tableOptions.checkedRows[index].isActive
                  shopstochange.push(shop)
                })
              })
          }
          for (let shopid in shopstochange) {
            await this.$db
              .collection('shops')
              .doc(shopstochange[shopid].id)
              .update(shopstochange[shopid])
          }
          this.multipleHiding('companies')
        },
        onCancel: () => {
          this.multipleHiding('companies')
        },
      })
    },
    deleteItemModal(item, collection) {
      this.$buefy.dialog.confirm({
        title: this.$translate('attention'),
        message: this.$translate('delete_confirm_text'),
        cancelText: this.$translate('undo'),
        confirmText: this.$translate('delete'),
        onConfirm: () => {
          this.deleteItem(item, collection)
        },
      })
    },
    changesearchQuery(querystring = '') {
      this.queryString = querystring
    },
    sortPressed(field, order) {
      if (field == 'address.country') {
        this.countriesFilterInfo.filterValue = '*'
        this.disabledcountry = true
      } else {
        this.disabledcountry = false
      }
      this.field = field
      this.order = order
      this.searchData()
    },
    searchData() {
      this.tableData = []
      this.tableOptions.loading = true

      //update filters
      this.$store.commit('setFiltersCompanies', {
        country: this.countriesFilterInfo.filterValue,
        catalog: this.catalogsFilterInfo.filterValue,
      })

      this.mainQuery = this.$db.collection('companies')
      this.mainQuery = this.mainQuery.where('searchArray', 'array-contains', this.queryString.toLowerCase())
      if (this.countriesFilterInfo.filterValue != '*') {
        this.mainQuery = this.mainQuery.where('address.country', '==', this.countriesFilterInfo.filterValue)
      }
      if (this.catalogsFilterInfo.filterValue != '*') {
        let tempcatsearch = this.catalogs.find(temp => temp.name == this.catalogsFilterInfo.filterValue)
        if (tempcatsearch != undefined) {
          this.mainQuery = this.mainQuery.where('catalog', '==', tempcatsearch.id)
        }
      }
      if (!this.showHidden) {
        this.mainQuery = this.mainQuery.where('isActive', '==', true)
      }
      if (this.field != null) {
        //console.log(this.order);
        this.mainQuery = this.mainQuery.orderBy(this.field, this.order)
      }
      this.lastRequested = null
      this.appendData()
    },
    async loadData() {
      this.tableOptions.loading = true
      await this.createFilters()

      //set latest filter used
      this.countriesFilterInfo.filterValue = this.$store.state.filters.companies.country
      this.catalogsFilterInfo.filterValue = this.$store.state.filters.companies.catalog

      this.tableData = []
      if (this.$route.params.companyId) {
        this.mainQuery = this.$db
          .collection('companies')
          .where(firebase.firestore.FieldPath.documentId(), '==', this.$route.params.companyId)
      }
      if (this.countriesFilterInfo.filterValue != '*') {
        this.mainQuery = this.mainQuery.where('address.country', '==', this.countriesFilterInfo.filterValue)
      }
      if (this.catalogsFilterInfo.filterValue != '*') {
        let tempcatsearch = this.catalogs.find(temp => temp.name == this.catalogsFilterInfo.filterValue)
        if (tempcatsearch != undefined) {
          this.mainQuery = this.mainQuery.where('catalog', '==', tempcatsearch.id)
        }
      }
      this.appendData()
    },
    appendData(newlimit = this.limit) {
      let thisQuery = this.mainQuery
      if (this.lastRequested != null) {
        thisQuery = thisQuery.startAt(this.lastRequested)
      }
      //console.log(this.companiesId);
      //console.log(this.companiesindex);

      if (!this.allCompanies) {
        thisQuery = thisQuery.where(
          firebase.firestore.FieldPath.documentId(),
          'in',
          this.companiesId.slice(this.companiesindex, this.companiesindex + 10)
        )
      }
      thisQuery
        .limit(this.limit + 1)
        .get()
        .then(docs => {
          this.disableRequestMore = docs.size <= this.limit
          let i = 0
          const newTableData = []
          docs.forEach(doc => {
            let newCompany = doc.data()
            newCompany.id = doc.id

            const tempcat = this.catalogs.find(temp => temp.id === newCompany.catalog)
            const tempcatFits = this.catalogs.find(temp => temp.id === newCompany.catalog_fits)
            const tempcatModular = this.catalogs.find(temp => temp.id === newCompany.catalog_modular)
            const tempcatInsole = this.catalogs.find(temp => temp.id === newCompany.catalog_insole)
            newCompany.catalog = tempcat ? tempcat : false
            newCompany.catalog_fits = tempcatFits ? tempcatFits : false
            newCompany.catalog_modular = tempcatModular ? tempcatModular : false
            newCompany.catalog_insole = tempcatInsole ? tempcatInsole : false

            i++
            if (i <= this.limit) {
              newTableData.push(newCompany)
            }
            this.lastRequested = doc
          })
          this.tableData = newTableData
          if (!this.allCompanies && this.companiesId.length > this.companiesindex + 10) {
            this.companiesindex += 10
            this.lastRequested = null
            this.appendData(newlimit - docs.size)
          }
          this.tableOptions.loading = false
        })
    },
    async createFilters() {
      this.countriesFilterInfo.options = [{ name: '*' }]
      this.catalogsFilterInfo.options = [{ name: '*' }]

      await this.$db
        .collection('catalogs')
        .get()
        .then(docs => {
          docs.forEach(doc => {
            let cat = doc.data()
            cat.id = doc.id
            this.catalogsFilterInfo.options.push({
              name: cat.name,
            })
            this.catalogs.push(cat)
          })
        })
      await this.$db
        .collection('countries')
        .get()
        .then(docs => {
          docs.forEach(doc => {
            this.countriesFilterInfo.options.push({
              name: doc.data().code,
            })
          })
        })
    },
  },
  mounted() {
    let permissionDenied = true
    switch (this.userInfo.type) {
      case 'A':
        permissionDenied = false
        this.permissions.canCreate = true
        this.permissions.canEdit = true
        this.permissions.canHide = true
        this.permissions.canDelete = true
        break
      case 'I':
        permissionDenied = false
        break
    }
    if (permissionDenied) this.$router.push('/forbidden')
    this.loadData()
  },
}
</script>

<style scoped>
.container>>>.table-footer td {
  color: #bdbdbd;
}

@media only screen and (min-width: 1280px) {
  .container>>>.b-table .table th {
    font-weight: 600;
    position: sticky;
    top: 120px;
    background: white;
    z-index: 8;
  }

  .first-level {
    height: 60px;
    background: white;
    top: 0px;
    position: sticky;
    z-index: 9;
    margin-top: 0;
    margin-bottom: 0;
  }

  .second-level {
    height: 60px;
    background: white;
    top: 60px;
    position: sticky;
    z-index: 8;
    margin-top: 0;
    margin-bottom: 0;
  }

  .container>>>.dropdown-menu {
    z-index: 5;
  }
}
</style>
